export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Staré heslo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nové heslo"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrzení hesla"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["''Nové heslo'' a ''Potvrzení hesla'' se neshodují."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Změna hesla"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Řetězec od 4 do 63 znaků. Povolené znaky jsou latinské písmena, číslice a symboly"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prázdné"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slabé"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Střední"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Silné"])}
  }
}